/// <amd-module name="Wit/BoardsHub/KanbanBoard/Utils/RoutingUtils" />

import { getTFSProject } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";

const backlogRoute = "ms.vss-work-web.new-backlogs-content-route";
const workItemFormRoute = "ms.vss-work-web.new-work-item-form-route";
const testHubRoute = "ms.vss-test-web.testplans-hub-refresh-route";

export function getBacklogUrl(pageContext: IVssPageContext, projectId: string, teamName: string, backlogLevel: string) {
    const routeValues = {
        backlogLevel,
        pivot: "backlog",
        project: projectId,
        teamName
    };

    return routeUrl(pageContext, backlogRoute, routeValues);
}

export function getWorkItemUrl(pageContext: IVssPageContext, workItemId: number) {
    const projectName = getTFSProject(pageContext)?.name;
    const routeValues = {
        project: projectName || "",
        id: "" + workItemId
    };
    return routeUrl(pageContext, workItemFormRoute, routeValues);
}

export function getTestPlanUrl(pageContext: IVssPageContext, projectId: string, testPlanId: number, testSuiteId: number) {
    const routeValues: { [key: string]: string } = {
        ["project"]: projectId,
        ["planId"]: testPlanId.toString(),
        ["suiteId"]: testSuiteId.toString()
    };

    return routeUrl(pageContext, testHubRoute, routeValues);
}
